// extracted by mini-css-extract-plugin
export default {"zoomModal":"h1-z","image":"i1-z","button":"j1-z","isOverlayShown":"k1-z"};